import { FormlyMatTextAreaModule } from '@ngx-formly/material/textarea';

import { NgModule } from '@angular/core';

@NgModule({
  imports: [FormlyMatTextAreaModule],
})
export class SnFormTextareaModule {}
